/**
 * Foredrags-innhold. Rediger denne filen for å legge til eller endre foredrag —
 * bundles inn på build-tid. Hvis lista vokser forbi ~30 oppføringer, flytt til
 * et backend-repo + YAML seed (samme mønster som profile).
 */

export type TalkFormat = "Hovedforedrag" | "Workshop" | "Panel" | "Podkast" | "Gjesteforelesning";

export interface Talk {
  /** ISO yyyy-mm-dd. Datoen viser når foredraget ble tilgjengelig/først holdt. */
  date: string;
  title: string;
  venue: string;
  /** Valgfri by/land. */
  location?: string;
  format: TalkFormat;
  /** Opptak, lysbilder, eller arrangementside. */
  href?: string;
  /** Eksplisitt override; ellers utledes fra dato. */
  upcoming?: boolean;
}

export const FORMATS: ReadonlyArray<TalkFormat> = [
  "Hovedforedrag",
  "Workshop",
  "Panel",
  "Podkast",
  "Gjesteforelesning",
];

/** Rediger denne lista. Rekkefølge spiller ingen rolle — renderen sorterer. */
export const TALKS: ReadonlyArray<Talk> = [
  {
    date: "2026-09-15",
    title: "Kunstig intelligens i praksis: når algoritmer møter virkeligheten",
    venue: "Åpent for booking",
    format: "Hovedforedrag",
    upcoming: true,
  },
  {
    date: "2023-06-01",
    title: "Forklarbar kunstig intelligens: fra modell til beslutning",
    venue: "Åpent for booking",
    format: "Hovedforedrag",
  },
  {
    date: "2024-01-15",
    title: "KI i offentlige tjenester: tillit, ansvar og faktisk nytte",
    venue: "Åpent for booking",
    format: "Panel",
  },
  {
    date: "2026-09-01",
    title: "Praktisk bruk av generativ AI i organisasjoner",
    venue: "Åpent for booking",
    format: "Workshop",
    upcoming: true,
  },
  {
    date: "2026-06-01",
    title: "Når algoritmer feiler: risiko, beredskap og beslutningsstøtte",
    venue: "Åpent for booking",
    format: "Hovedforedrag",
  },
  {
    date: "2022-05-20",
    title: "Fra data til handling: AI-systemer folk faktisk bruker",
    venue: "Åpent for booking",
    format: "Workshop",
  },
  {
    date: "2024-03-20",
    title: "Fra benchmarks til virkelighet: hva CaiRL har lært oss",
    venue: "Åpent for booking",
    format: "Gjesteforelesning",
  },
  {
    date: "2024-03-10",
    title: "Tsetlin-maskiner i praksis",
    venue: "Åpent for booking",
    format: "Workshop",
  },
];

export const BOOKING_EMAIL = "per@sysx.no";
export const BOOKING_SUBJECT = "Foredragsforespørsel";
export const BOOKING_BODY = [
  "Hei Per-Arne,",
  "",
  "Jeg vil gjerne invitere deg til å holde foredrag på ____.",
  "",
  "Format:    hovedforedrag / workshop / panel / podkast / gjesteforelesning",
  "Dato:      ____",
  "Sted:      ____ (eller digitalt)",
  "Publikum:  ____",
  "Tema:      ____",
  "",
  "Takk!",
].join("\n");

export function mailtoBooking(): string {
  const params = new URLSearchParams({
    subject: BOOKING_SUBJECT,
    body: BOOKING_BODY,
  });
  return `mailto:${BOOKING_EMAIL}?${params.toString()}`;
}

export function isUpcoming(talk: Talk, now = new Date()): boolean {
  if (talk.upcoming !== undefined) return talk.upcoming;
  return new Date(talk.date).getTime() > now.getTime();
}

export function sortByDateDesc(talks: ReadonlyArray<Talk>): Talk[] {
  return [...talks].sort((a, b) => b.date.localeCompare(a.date));
}
